{
	"after": "After",
	"before": "Before",
	"samplePhotos": "Sample photos"
}
